import { render } from "./SearchCompanysView.vue?vue&type=template&id=5da1c036&scoped=true"
import script from "./SearchCompanysView.vue?vue&type=script&lang=js"
export * from "./SearchCompanysView.vue?vue&type=script&lang=js"

import "./SearchCompanysView.vue?vue&type=style&index=0&id=5da1c036&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da1c036"]])

export default __exports__